import React from 'react';
import styled from '@benzinga/themetron';
import { Icon } from '@benzinga/core-ui';
import { faEye, faEyeSlash } from '@fortawesome/pro-regular-svg-icons';

export interface AuthInputProps {
  label?: string | JSX.Element | null;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  placeholder?: string;
  type: string;
  value: string;
  disabled?: boolean;
  name: string;
}

export const AuthInput = ({
  disabled,
  label,
  name,
  onChange,
  onKeyDown,
  placeholder,
  type,
  value,
  ...props
}: AuthInputProps & React.InputHTMLAttributes<HTMLInputElement>) => {
  return (
    <AuthInputWrapper>
      {label ? <label>{label}</label> : null}
      <div className="input-wrapper">
        <input
          {...props}
          className="text-lg"
          disabled={disabled}
          name={name}
          onChange={onChange}
          onKeyDown={onKeyDown}
          placeholder={typeof label === 'string' ? label : placeholder}
          style={{
            border: 'none',
            boxShadow: 'none',
          }}
          type={type}
          value={value}
        />
      </div>
    </AuthInputWrapper>
  );
};

export type AuthPasswordInputProps = Omit<AuthInputProps, 'type'> &
  React.InputHTMLAttributes<HTMLInputElement> & {
    hidden: boolean;
    toggleHidden: () => void;
  };

export const AuthPasswordInput = ({
  disabled,
  hidden,
  label,
  name,
  onChange,
  onKeyDown,
  placeholder,
  toggleHidden,
  value,
  ...props
}: AuthPasswordInputProps) => {
  return (
    <AuthInputWrapper>
      {label ? <label>{label}</label> : null}
      <div className="input-wrapper">
        <input
          {...props}
          className="text-lg"
          disabled={disabled}
          name={name}
          onChange={onChange}
          onKeyDown={onKeyDown}
          placeholder={typeof label === 'string' ? label : placeholder}
          style={{
            border: 'none',
            boxShadow: 'none',
          }}
          type={hidden ? 'password' : 'text'}
          value={value}
        />
      </div>
      <button className="eye-button" onClick={toggleHidden} type="button">
        <Icon icon={hidden ? faEye : faEyeSlash} />
      </button>
    </AuthInputWrapper>
  );
};

const AuthInputWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  padding: 16px 24px 16px 16px;
  gap: 16px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 0.5px solid #e1ebfa;
  background: #f2f8ff;
  label {
    font-size: 0.8rem;
    z-index: 2;
    color: #5b7292;
  }
  input {
    width: 100%;
    display: inline-block;
    padding: 0.8rem 0;
    outline: none !important;
    border: 0px solid #fff !important;
    background: transparent;
    color: #5b7292;
  }
  .eye-button {
    width: 20px;
    height: 20px;
  }
  .input-wrapper {
    /* border: solid 1px ${({ theme }) => theme.colorPalette.gray300}; */
    font-size: ${({ theme }) => theme.fontSize.sm};
    overflow: hidden;
    border-radius: 4px;
    width: 100%;
    input {
      line-height: 1.5rem;
      width: 100%;
      padding: 0.25rem 0;
      &:focus {
        outline: none;
      }
    }
  }
`;

export const AuthBoxWrapper = styled.div`
  .action-container {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    display: inline-flex;
    width: 100%;
    button {
      width: 100%;
      .action-text {
        width: 100%;
        text-align: center;
      }
    }
  }
`;
